import {Component, Input, OnInit} from '@angular/core';
import {CommonModule, NgIf, NgStyle} from "@angular/common";
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
  animations: [
    trigger('slideUpDown', [
      state('collapsed', style({
        height: '0',
        paddingTop: '0',
        paddingBottom: '0',
        opacity: '0'
      })),
      state('expanded', style({
        height: '*',
        paddingTop: '*',
        paddingBottom: '*',
        opacity: '1'
      })),
      transition('collapsed <=> expanded', animate('300ms ease-in-out'))
    ])
  ],
  imports: [
    NgStyle,
    NgIf,
    CommonModule
  ],
  selector: 'app-section-card',
  standalone: true,
  styleUrl: './section-card.component.scss',
  templateUrl: './section-card.component.html',
})
export class SectionCardComponent  {
  @Input() title: string = '';
  @Input() enableToggle: boolean = true;
  @Input() cardWidth: string = 'auto';
  @Input() backgroundColor: string = 'var(--grey-neutral-50)';
  @Input() cssClass?: string;

  isExpanded = true;

  toggleSection() {
    if (this.enableToggle) {
      this.isExpanded = !this.isExpanded;
    }
  }
}
